import { useEffect, useRef } from 'react';
import { startRingback } from '../sound';

export function useOutgoingRingback(outgoing: boolean) {
  const stopRef = useRef<(() => void) | null>(null);
  useEffect(() => {
    if (!outgoing) return;
    const stop = startRingback();
    // Отбой и cleanup эффекта используют одну остановку, даже при повторном вызове.
    let stopped = false;
    const stopOnce = () => {
      if (stopped) return;
      stopped = true;
      stopRef.current = null;
      stop();
    };
    stopRef.current = stopOnce;
    return stopOnce;
  }, [outgoing]);
  return stopRef;
}
